import { Skeleton } from "src/@/components/ui/skeleton"

export function SkeletonCardInfoDashboard() {
  return (
    <div className="flex items-center space-x-4 bg-slate-200 w-full rounded-sm h-[90px]">
      <div className="space-y-2">
        <Skeleton className="h-4 w-[250px] ml-2" />
        <Skeleton className="h-4 w-[200px] ml-2" />
      </div>
    </div>
  )
}
